module.exports = __webpack_public_path__ + "img/1.9b603a00.png";